<template>
  <a-modal v-model:visible="visible" :title="$t('_hb._fhb')" @ok="hide" @cancel="hide" :cancelText="$t('recharge.cancel.text')">
    <a-form ref="form" :model="formState" name="basic" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" autocomplete="off">
      <a-form-item :label="$t('_hb._fsd')">
        <div style="display: flex; gap: 10px; align-items: center">
          <div>
            <img style="width: 40px; height: 40px" :src="currentChat.avatar" />
          </div>
          <div>
            <div style="font-weight: 700">{{ currentChat.name || '' }}</div>
            <div class="">{{ currentChat.uid || '' }}</div>
          </div>
        </div>
      </a-form-item>

      <a-form-item :label="$t('_hb._dqye')">
        <div class="price">$ {{ wallet.balance || 0 }}</div>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 8 }" :label="$t('_hb._hbje')" name="amount" :rules="[{ required: true, message: $t('_hb._qshuru') }]">
        <a-input v-model:value="formState.amount" :placeholder="$t('_hb._qshuru')" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 16 }" :label="$t('_hb._hbz')" name="title" :rules="[{ required: true, message: $t('_hb._qshuruzhu') }]">
        <a-input v-model:value="formState.title" :placeholder="$t('_hb._qshuruzhu')" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button key="submit" type="primary" :loading="btnLoad" @click="onGiftSave">{{ $t('_hb._ljfs') }}</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'RechargeVue',
  components: {},
  data() {
    return {
      //存币
      visible: false,
      btnLoad: false,

      //赠送对象
      currentChat: {},
      //
      formState: {
        amount: '',
        title: ''
      },

      // 钱包
      wallet: { balance: '0.00' }
    }
  },
  created() {},
  methods: {
    onGiftSave() {
      const that = this
      that.btnLoad = true
      this.$refs.form.validateFields().then((values) => {
        values.session_id = that.currentChat.id
        console.log(values)
        that.btnLoad = false
        this.visible = false
        that.$emit('success', values)
      })
    },
    /**
     * 存币
     */
    show(currentChat) {
      this.formState = {}
      if (currentChat.id > 0) {
        this.visible = true
        this.currentChat = currentChat
        this.getWallet()
      } else {
        this.$message.error({ content: 'error' })
      }
    },
    getWallet() {
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        that.wallet = res.data
      })
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style></style>
